import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-features-services-area',
  templateUrl: './features-services-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './features-services-area.component.scss'
})
export class FeaturesServicesAreaComponent {
  @Input() title1 : string = "";
  @Input() subtitle1 : string = "";
  @Input() detail1 : string = "";

  @Input() title2 : string = "";
  @Input() subtitle2 : string = "";
  @Input() detail2 : string = "";

  @Input() title3 : string = "";
  @Input() subtitle3 : string = "";
  @Input() detail3 : string = "";

  @Input() title4 : string = "";
  @Input() subtitle4 : string = "";
  @Input() detail4 : string = "";
}
